import { defineStore } from 'pinia'
import apiFetch from '@wordpress/api-fetch'

export const useRegionsStore = defineStore('regions', {
  state: () => ({
    regions: [],
    activeRegions: [],
  }),

  actions: {
    loadRegions(params = {}) {
      this.regions = [];

      try {
        const context = this;
        const query = new URLSearchParams();

        if (params.lang) {
          query.append('lang', params.lang);
        }

        apiFetch({
          path: `/wp-json/ebus/regions?${query.toString()}`,
        }).then((regionsData) => {
          context.regions = regionsData;
        });
      } catch (error) {
        console.log('Error: ', error);
      }
    },

    toggleRegion(region) {
      const index = this.activeRegions.indexOf(region);

      if (index === -1) {
        this.activeRegions.push(region);
      } else {
        this.activeRegions.splice(index, 1);
      }
    },

    resetActiveRegions() {
      this.activeRegions = [];
    },
  },
})
